import React from 'react';
import { TshirtCarousel } from './components/TshirtCarousel';
import { FeaturesCarousel } from './components/FeaturesCarousel';
import { PurchaseNotification } from './components/PurchaseNotification';
import { TestimonialCard } from './components/TestimonialCard';
import { Check, ShieldCheck, ArrowRight, Gift, AlertTriangle, Zap, Clock, Database, Printer, Rocket } from 'lucide-react';
export function App() {
  const scrollToPurchase = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const testimonials = [{
    name: 'Lucas B.',
    age: 24,
    city: 'Buenos Aires',
    quote: 'El Kit está BRUTAL, mi negocio es puro de anime y la cantidad de diseños que hay es increíble y están todos buenísimos, no paro de vender 😎'
  }, {
    name: 'Martín A.',
    age: 29,
    city: 'Córdoba',
    quote: 'Me quedé sin laburo y empecé a laburar con la plancha de la ropa. Me puse una marca de street wear y en el primer mes me pude comprar la sublimadora, ya subimos de nivel mil gracias!!'
  }, {
    name: 'Ezequiel R.',
    age: 32,
    city: 'Rosario',
    quote: 'Estaba asfixiado del laburo, junté unos pesos y me compré la máquina pero estaba buscando diseños todo el día y eran todos una cagada. Con el kit resolví ese tema y ahora soy imparable, vendo hasta cuando no estoy.'
  }, {
    name: 'Carolina L.',
    age: 34,
    city: 'Mendoza',
    quote: 'Nunca pensé que sería tan fácil. El paso a paso es clarísimo y el soporte es excelente. Ya recuperé la inversión en la primera semana.'
  }, {
    name: 'Sofía M.',
    age: 27,
    city: 'La Plata',
    quote: 'Los diseños de tazas son hermosos, mis clientes están encantados. Es la mejor inversión que hice para mi emprendimiento.'
  }];
  const faqs = [{
    q: '¿Qué recibo al comprar el Kit?',
    a: 'Recibís acceso inmediato a una plataforma con más de 500.000 diseños organizados por categorías, listos para descargar e imprimir. Incluye diseños para remeras, tazas, almohadones y más.'
  }, {
    q: '¿Cuándo me llega?',
    a: 'El acceso es INMEDIATO. Una vez confirmado el pago, recibís un correo con tus datos de acceso a la plataforma para empezar a descargar al instante.'
  }, {
    q: '¿Cómo lo recibo?',
    a: 'Todo es 100% digital. No hay envío físico. Recibís acceso a nuestra nube privada donde están alojados todos los archivos.'
  }, {
    q: '¿Es físico o digital?',
    a: 'Es un producto 100% DIGITAL. Son archivos para que vos imprimas y estampes.'
  }, {
    q: '¿Necesito ser profesional?',
    a: 'Para nada. El kit está pensado tanto para principiantes como para expertos. Los archivos vienen listos para usar.'
  }, {
    q: '¿Tengo acceso para siempre?',
    a: 'Sí, el acceso es de por vida. Pagás una sola vez y accedés para siempre, incluyendo las actualizaciones futuras.'
  }, {
    q: '¿Qué hago si no me llega el acceso?',
    a: 'Revisá tu carpeta de Spam o Promociones. Si no está ahí, escribinos a nuestro soporte y te lo solucionamos en el acto.'
  }, {
    q: '¿Es una compra segura?',
    a: 'Totalmente. Utilizamos pasarelas de pago encriptadas y seguras. Tu información está protegida.'
  }];
  return <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden" data-id="element-0">
      <PurchaseNotification data-id="element-1" />

      {/* HERO SECTION */}
      <header className="bg-gradient-to-b from-blue-50 to-white pt-8 pb-12 px-4" data-id="element-2">
        <div className="max-w-4xl mx-auto text-center" data-id="element-3">
          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight" data-id="element-4">
            <span className="text-pink-500 underline decoration-4 decoration-pink-200" data-id="element-5">
              Un año de diseños resueltos
            </span>{' '}
            probados para que tu marca sea{' '}
            <span className="text-pink-500 font-black" data-id="element-6">viral.</span>
          </h1>

          <div className="mb-8" data-id="element-7">
            <img src="https://cdn.magicpatterns.com/uploads/oZynawTfPVbxBaC1czX569/MOKCUP_PRINCIPAL.png" alt="Kit Sublimación & DTF Viral" className="w-full max-w-3xl mx-auto rounded-xl shadow-2xl cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToPurchase} data-id="element-8" />
          </div>

          <p className="text-lg md:text-xl text-gray-700 font-medium mb-8 max-w-2xl mx-auto" data-id="element-9">
            Anime - Videojuegos - Marcas - Artistas - Tendencias - Brainrot -
            Marvel - Dc - Series - Formula 1 - Autos - Kpop - Religión - Duos -
            Funkos - Rock - Fantasia - Acción - Y mucho más.
          </p>

          <button onClick={scrollToPurchase} className="bg-orange-500 hover:bg-orange-600 text-white text-xl font-bold py-4 px-8 rounded-full shadow-lg transform transition hover:scale-105 flex items-center justify-center gap-2 mx-auto w-full max-w-md" data-id="element-10">
            SÍ, QUIERO EL KIT AHORA
            <ArrowRight className="w-6 h-6" data-id="element-11" />
          </button>
        </div>
      </header>

      {/* URGENCY BANNER */}
      <div className="bg-black text-white py-8 px-4 text-center" data-id="element-12">
        <h2 className="text-2xl md:text-4xl font-black uppercase tracking-wide mb-6" data-id="element-13">
          2026 es tu año, y el{' '}
          <span className="text-orange-500" data-id="element-14">80% ya lo tenés resuelto.</span>
        </h2>
        <FeaturesCarousel data-id="element-15" />
      </div>

      {/* PROBLEM SECTION */}
      <section className="py-16 px-4" style={{
      background: 'linear-gradient(180deg, #1F3F5F 0%, #2E6FA3 100%)'
    }} data-id="element-16">
        <div className="max-w-3xl mx-auto" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-18">
            Lo que intentaste hasta ahora no alcanza...
          </h2>

          <div className="space-y-8" data-id="element-19">
            <div className="flex gap-4 items-start" data-id="element-20">
              <div className="bg-white/10 p-3 rounded-lg flex-shrink-0" data-id="element-21">
                <Clock className="w-8 h-8 text-orange-400" data-id="element-22" />
              </div>
              <div data-id="element-23">
                <h3 className="text-xl font-bold mb-2 text-white" data-id="element-24">
                  Perdés horas diseñando
                </h3>
                <p className="text-blue-100" data-id="element-25">
                  O buscando diseños que no sabés si se van a vender. El tiempo
                  es dinero y lo estás perdiendo.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start" data-id="element-26">
              <div className="bg-white/10 p-3 rounded-lg flex-shrink-0" data-id="element-27">
                <AlertTriangle className="w-8 h-8 text-orange-400" data-id="element-28" />
              </div>
              <div data-id="element-29">
                <h3 className="text-xl font-bold mb-2 text-white" data-id="element-30">
                  Repetís diseños quemados
                </h3>
                <p className="text-blue-100" data-id="element-31">
                  Y te frustras porque ves al resto vender pero tu marca sigue
                  igual. Necesitás diferenciarte.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start" data-id="element-32">
              <div className="bg-white/10 p-3 rounded-lg flex-shrink-0" data-id="element-33">
                <Zap className="w-8 h-8 text-orange-400" data-id="element-34" />
              </div>
              <div data-id="element-35">
                <h3 className="text-xl font-bold mb-2 text-white" data-id="element-36">
                  Le metés ganas, pero no ves resultados
                </h3>
                <p className="text-blue-100" data-id="element-37">
                  Sin un catálogo variado perdés volumen de ventas. La variedad
                  es clave para escalar.
                </p>
              </div>
            </div>

            <div className="flex gap-4 items-start" data-id="element-38">
              <div className="bg-white/10 p-3 rounded-lg flex-shrink-0" data-id="element-39">
                <AlertTriangle className="w-8 h-8 text-orange-400" data-id="element-40" />
              </div>
              <div data-id="element-41">
                <h3 className="text-xl font-bold mb-2 text-white" data-id="element-42">
                  Improvisas todos los días
                </h3>
                <p className="text-blue-100" data-id="element-43">
                  Y te abruma no saber que vender. La incertidumbre mata
                  cualquier negocio.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-12 p-6 bg-white/10 rounded-xl border border-white/20 backdrop-blur-sm" data-id="element-44">
            <ul className="space-y-3 text-lg font-medium text-white" data-id="element-45">
              <li className="flex items-center gap-2" data-id="element-46">
                👉 La máquina ya la tenés.
              </li>
              <li className="flex items-center gap-2" data-id="element-47">
                👉 El problema no es el esfuerzo.
              </li>
              <li className="flex items-center gap-2 text-orange-400 font-bold" data-id="element-48">
                👉 Son los diseños que estás usando.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* SOLUTION SECTION */}
      <section className="py-16 px-4 text-white" style={{
      background: 'linear-gradient(360deg, #1F3F5F 0%, #2E6FA3 100%)'
    }} data-id="element-49">
        <div className="max-w-3xl mx-auto" data-id="element-50">
          <h2 className="text-3xl md:text-5xl font-black text-center mb-12 leading-tight" data-id="element-51">
            Por eso creamos el
            <br data-id="element-52" />
            <span className="text-pink-400" data-id="element-53">
              💎 KIT VIRAL SUBLIMACIÓN & DTF 💎
            </span>
          </h2>

          <div className="grid gap-8" data-id="element-54">
            <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm" data-id="element-55">
              <div className="flex items-center gap-3 mb-3" data-id="element-56">
                <Database className="w-6 h-6 text-pink-300" data-id="element-57" />
                <h3 className="text-xl font-bold" data-id="element-58">
                  Miles de diseños organizados
                </h3>
              </div>
              <p className="text-blue-50" data-id="element-59">
                Por categorías y subcarpetas para que encontrar el indicado esté
                a un solo clic.
              </p>
            </div>

            <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm" data-id="element-60">
              <div className="flex items-center gap-3 mb-3" data-id="element-61">
                <Printer className="w-6 h-6 text-pink-300" data-id="element-62" />
                <h3 className="text-xl font-bold" data-id="element-63">
                  Diseños pensados para producción real
                </h3>
              </div>
              <p className="text-blue-50" data-id="element-64">
                Dejá de improvisar y empezá a vender desde el primer día.
              </p>
            </div>

            <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm" data-id="element-65">
              <div className="flex items-center gap-3 mb-3" data-id="element-66">
                <Clock className="w-6 h-6 text-pink-300" data-id="element-67" />
                <h3 className="text-xl font-bold" data-id="element-68">
                  Te ahorra horas todos los días
                </h3>
              </div>
              <p className="text-blue-50" data-id="element-69">
                Olvidate de buscar ideas que no funcionan y enfocá tu tiempo en
                vender.
              </p>
            </div>

            <div className="bg-white/10 p-6 rounded-xl backdrop-blur-sm" data-id="element-70">
              <div className="flex items-center gap-3 mb-3" data-id="element-71">
                <Rocket className="w-6 h-6 text-pink-300" data-id="element-72" />
                <h3 className="text-xl font-bold" data-id="element-73">
                  Un solo sistema para dejar de improvisar
                </h3>
              </div>
              <p className="text-blue-50" data-id="element-74">
                Pasá de "tengo una máquina" a "tengo un negocio que factura".
              </p>
            </div>
          </div>

          <div className="mt-12" data-id="element-75">
            <TshirtCarousel data-id="element-76" />
          </div>
        </div>
      </section>

      {/* WHAT YOU GET SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-77">
        <div className="max-w-3xl mx-auto" data-id="element-78">
          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-12" data-id="element-79">
            Por qué{' '}
            <span className="text-pink-600" data-id="element-80">KIT SUBLIMACIÓN & DTF VIRAL</span>{' '}
            es único y especial
          </h2>

          <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-200 mb-12" data-id="element-81">
            <h3 className="text-2xl font-bold mb-6 flex items-center gap-2" data-id="element-82">
              <span className="bg-green-500 text-white p-1 rounded" data-id="element-83">✅</span>{' '}
              ¿Qué vas a recibir?
            </h3>
            <ul className="space-y-6" data-id="element-84">
              <li className="flex gap-4" data-id="element-85">
                <div className="bg-gray-100 p-2 rounded h-fit" data-id="element-86">
                  <Database className="w-5 h-5 text-gray-600" data-id="element-87" />
                </div>
                <div data-id="element-88">
                  <h4 className="font-bold text-lg" data-id="element-89">
                    Acceso al KIT SUBLIMACIÓN & DTF VIRAL
                  </h4>
                  <p className="text-gray-600" data-id="element-90">
                    Miles de archivos compatibles y editables para que comiences
                    a vender.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-91">
                <div className="bg-gray-100 p-2 rounded h-fit" data-id="element-92">
                  <Clock className="w-5 h-5 text-gray-600" data-id="element-93" />
                </div>
                <div data-id="element-94">
                  <h4 className="font-bold text-lg" data-id="element-95">
                    Te ahorra horas todos los días
                  </h4>
                  <p className="text-gray-600" data-id="element-96">
                    Olvidate de buscar imágenes mal recortadas, de baja calidad
                    o que no sirven para sublimar.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-97">
                <div className="bg-gray-100 p-2 rounded h-fit" data-id="element-98">
                  <Rocket className="w-5 h-5 text-gray-600" data-id="element-99" />
                </div>
                <div data-id="element-100">
                  <h4 className="font-bold text-lg" data-id="element-101">🚀 Bonos imperdibles</h4>
                  <p className="text-gray-600" data-id="element-102">
                    Diseños de almohadones, Ojotas o Flip Flops, Bolsos y
                    Stickers
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-xl border border-gray-200" data-id="element-103">
            <h3 className="text-2xl font-bold mb-6 flex items-center gap-2" data-id="element-104">
              <span className="bg-green-500 text-white p-1 rounded" data-id="element-105">✅</span>{' '}
              ¿Qué vas a lograr con Kit Sublimación y DTF Viral?
            </h3>
            <ul className="space-y-6" data-id="element-106">
              <li className="flex gap-4" data-id="element-107">
                <div className="bg-gray-100 p-2 rounded h-fit text-2xl" data-id="element-108">👕</div>
                <div data-id="element-109">
                  <h4 className="font-bold text-lg" data-id="element-110">
                    Vender productos sublimados y DTF desde la primer semana
                  </h4>
                  <p className="text-gray-600" data-id="element-111">
                    Con imágenes listas para imprimir y cobrar, sin depender de
                    terceros.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-112">
                <div className="bg-gray-100 p-2 rounded h-fit text-2xl" data-id="element-113">🎯</div>
                <div data-id="element-114">
                  <h4 className="font-bold text-lg" data-id="element-115">
                    Producir con seguridad y sin improvisar
                  </h4>
                  <p className="text-gray-600" data-id="element-116">
                    Usando imágenes probadas y compatibles para producción real
                    en sublimación y DTF.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-117">
                <div className="bg-gray-100 p-2 rounded h-fit text-2xl" data-id="element-118">📲</div>
                <div data-id="element-119">
                  <h4 className="font-bold text-lg" data-id="element-120">
                    Publicar y vender por redes sociales con más confianza
                  </h4>
                  <p className="text-gray-600" data-id="element-121">
                    Teniendo siempre contenido visual listo para ofrecer y
                    atraer clientes.
                  </p>
                </div>
              </li>
              <li className="flex gap-4" data-id="element-122">
                <div className="bg-gray-100 p-2 rounded h-fit text-2xl" data-id="element-123">💸</div>
                <div data-id="element-124">
                  <h4 className="font-bold text-lg" data-id="element-125">
                    Convertir tu impresora en un negocio que factura
                  </h4>
                  <p className="text-gray-600" data-id="element-126">
                    Y dejar de verla solo como una máquina más parada.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* BONUSES SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-127">
        <div className="max-w-4xl mx-auto text-center" data-id="element-128">
          <h2 className="text-3xl font-black mb-4" data-id="element-129">¡PERO ESO NO ES TODO!</h2>
          <p className="text-xl text-gray-700 mb-12" data-id="element-130">
            Accediendo hoy te damos estos BONOS EXCLUSIVOS:
          </p>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-131">
            <div className="bg-gray-50 p-6 rounded-2xl border-2 border-gray-200 hover:border-blue-500 transition-colors" data-id="element-132">
              <div className="text-blue-600 font-black text-xl mb-4" data-id="element-133">
                BONO 1
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/mv8tYkEivLxVXMQW4AZNPs/BONO_1_SUBLIMACION.png" alt="Bono 1: Almohadones Virales" className="w-full rounded-lg mb-4 shadow-md" data-id="element-134" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-135">Almohadones virales</h3>
              <p className="text-gray-600 mb-4" data-id="element-136">
                +10.000 diseños de almohadones con las ultimas tendencias.
              </p>
              <div className="text-blue-600 font-bold" data-id="element-137">
                GRATIS HOY CON TU COMPRA
              </div>
            </div>

            <div className="bg-gray-50 p-6 rounded-2xl border-2 border-gray-200 hover:border-blue-500 transition-colors" data-id="element-138">
              <div className="text-blue-600 font-black text-xl mb-4" data-id="element-139">
                BONO 2
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/qjyXZNhtYYeCBtTX4ie4LC/BONO_2_SUBLIMACION.png" alt="Bono 2: Diseños de Tazas" className="w-full rounded-lg mb-4 shadow-md" data-id="element-140" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-141">Diseños de tazas</h3>
              <p className="text-gray-600 mb-4" data-id="element-142">
                +10.000 diseños de tazas virales.
              </p>
              <div className="text-blue-600 font-bold" data-id="element-143">
                GRATIS HOY CON TU COMPRA
              </div>
            </div>

            <div className="bg-gray-50 p-6 rounded-2xl border-2 border-gray-200 hover:border-blue-500 transition-colors" data-id="element-144">
              <div className="text-blue-600 font-black text-xl mb-4" data-id="element-145">
                BONO 3
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/84dAjbnUdjU3zA6gMsbh91/BONO_3_SUBLIMACION.png" alt="Bono 3: Stickers Virales" className="w-full rounded-lg mb-4 shadow-md" data-id="element-146" />
              <h3 className="text-2xl font-bold mb-4" data-id="element-147">Stickers virales</h3>
              <p className="text-gray-600 mb-4" data-id="element-148">
                Stickers imperdibles para complementar tus ventas.
              </p>
              <div className="text-blue-600 font-bold" data-id="element-149">
                GRATIS HOY CON TU COMPRA
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OFFER SECTION */}
      <section id="compra" className="py-16 px-4 bg-gray-100" data-id="element-150">
        <div className="max-w-2xl mx-auto" data-id="element-151">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-blue-600 relative" data-id="element-152">
            <div className="absolute top-4 left-0 bg-blue-600 text-white px-12 py-2 font-bold transform -rotate-45 -translate-x-10 shadow-lg z-10 text-sm" data-id="element-153">
              OFERTA ESPECIAL
            </div>

            <div className="p-8 text-center bg-gray-50 border-b border-gray-200 pt-16" data-id="element-154">
              <h2 className="text-3xl font-black text-gray-900" data-id="element-155">
                🎉 OFERTA POR TIEMPO LIMITADO
              </h2>
              <p className="text-gray-600 mt-2" data-id="element-156">
                Estás a un paso de acceder al KIT SUBLIMACIÓN & DTF VIRAL
              </p>
            </div>

            <div className="p-8" data-id="element-157">
              <div className="mb-8" data-id="element-158">
                <img src="https://cdn.magicpatterns.com/uploads/oZynawTfPVbxBaC1czX569/MOKCUP_PRINCIPAL.png" alt="Kit Sublimación & DTF Viral" className="w-full rounded-xl shadow-lg mb-6" data-id="element-159" />
              </div>

              <ul className="space-y-4 mb-8" data-id="element-160">
                <li className="flex items-start gap-3" data-id="element-161">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-162" />
                  <span className="font-bold text-gray-800" data-id="element-163">
                    +500.000 imágenes virales para Sublimación y DTF
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-164">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-165" />
                  <span className="text-gray-700" data-id="element-166">
                    Archivos compatibles y optimizados para producción real
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-167">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-168" />
                  <span className="text-gray-700" data-id="element-169">
                    Diseños realmente buscados por el mercado
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-170">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-171" />
                  <span className="text-gray-700" data-id="element-172">
                    Ahorro brutal de tiempo todos los días
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-173">
                  <Gift className="w-6 h-6 text-pink-500 flex-shrink-0" data-id="element-174" />
                  <span className="font-bold text-pink-600" data-id="element-175">
                    BONO: Almohadones Virales (+10.000 diseños)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-176">
                  <Gift className="w-6 h-6 text-pink-500 flex-shrink-0" data-id="element-177" />
                  <span className="font-bold text-pink-600" data-id="element-178">
                    BONO: Diseños de Tazas (+10.000 diseños)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-179">
                  <Gift className="w-6 h-6 text-pink-500 flex-shrink-0" data-id="element-180" />
                  <span className="font-bold text-pink-600" data-id="element-181">
                    BONO: Stickers Virales
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-182">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-183" />
                  <span className="text-gray-700" data-id="element-184">
                    Actualizaciones constantes de contenido
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-185">
                  <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-186" />
                  <span className="text-gray-700" data-id="element-187">Soporte 24/7</span>
                </li>
              </ul>

              <div className="text-center mb-8" data-id="element-188">
                <p className="text-gray-500 text-lg md:text-xl line-through mb-2" data-id="element-189">
                  ¡Antes $49.900ARS!
                </p>
                <p className="text-2xl md:text-3xl font-black text-gray-900 mb-2" data-id="element-190">
                  SOLO POR HOY
                </p>
                <p className="text-4xl md:text-5xl font-black text-green-500 mb-4" data-id="element-191">
                  $19.990AR
                </p>
                <p className="text-base md:text-lg font-bold text-gray-800" data-id="element-192">
                  ¡Hasta en 3 cuotas fijas!
                </p>
              </div>

              <a href="https://checkout.rincondigital.shop/cart/52880185065747:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-orange-500 hover:bg-orange-600 text-white text-center text-xl md:text-2xl font-bold py-6 rounded-xl shadow-xl transform transition hover:scale-105 animate-pulse" data-id="element-193">
                SI, QUIERO LA OFERTA AHORA
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE SECTION */}
      <section className="py-16 px-4 text-white text-center" style={{
      background: 'linear-gradient(180deg, #1F3F5F 0%, #2E6FA3 100%)'
    }} data-id="element-194">
        <div className="max-w-2xl mx-auto" data-id="element-195">
          <ShieldCheck className="w-20 h-20 mx-auto mb-6 text-orange-400" data-id="element-196" />
          <h2 className="text-3xl font-bold mb-6" data-id="element-197">Garantía sin vueltas</h2>
          <p className="text-lg text-blue-100 mb-8" data-id="element-198">
            Estamos tan seguros de que este Programa te va a encantar, que si no
            es así, te devolvemos el 100% de tu dinero.
          </p>
          <p className="text-blue-200" data-id="element-199">
            Tenés 7 días para probarlo sin riesgo. Si no te convence, nos
            escribís y te hacemos el reembolso. Así de simple.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS SECTION */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-200">
        <div className="max-w-6xl mx-auto" data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-12" data-id="element-202">
            Testimonios
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-203">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-204" />)}
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="py-16 px-4 bg-white" data-id="element-205">
        <div className="max-w-3xl mx-auto" data-id="element-206">
          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-12" data-id="element-207">
            Resolvé aquí tus <span className="text-blue-600" data-id="element-208">DUDAS</span>
          </h2>

          <div className="space-y-4" data-id="element-209">
            {faqs.map((faq, i) => <div key={i} className="border-b border-gray-200 py-4" data-id="element-210">
                <details className="group" data-id="element-211">
                  <summary className="flex justify-between items-center font-bold text-lg cursor-pointer list-none text-gray-800 hover:text-blue-600" data-id="element-212">
                    <span data-id="element-213">{faq.q}</span>
                    <span className="transition group-open:rotate-180" data-id="element-214">
                      <svg fill="none" height="24" shapeRendering="geometricPrecision" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="24" data-id="element-215">
                        <path d="M6 9l6 6 6-6" data-id="element-216"></path>
                      </svg>
                    </span>
                  </summary>
                  <p className="text-gray-600 mt-3 group-open:animate-fadeIn" data-id="element-217">
                    {faq.a}
                  </p>
                </details>
              </div>)}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-218">
        <p data-id="element-219">Copyright 2025 - Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-220">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio no está respaldado por Facebook de ninguna manera.
        </p>
      </footer>
    </div>;
}